module.exports = __webpack_public_path__ + "static/camera4-1679058f87b4a7d99110edfaecf4938f.jpg";